<ng-container *ngLet="{
    _user: userState.user$ | async,
    _mobile:settingsService.screenBreakpoint$
      | async
      | appScreenLessThan: BreakpointTypeEnum.HalfSmall} as obj
  ">
  <div class="navigation-panel__bar --flex --jc-space --align-center"
    [class.navigation-panel__bar--floating]="scrolled">
    <app-svg type="none" class="--crsr-pntr" [src]="themeState.logo$ | async" (click)="onLogoClick()"></app-svg>

    <div class="--flex pdng-8 h-100" [ngClass]="{'wi-50': scrolled}">
      <ng-container *ngIf="obj._user && !obj._user.anonymous; else loginBtn">
        <div *ngIf="!scrolled" class=" action_btn --flex --align-center --gap-8 --crsr-pntr">
          <app-svg *ngIf="!scrolled" src="/assets/img/logout-2.svg" type="stroke" subType="main"></app-svg>
          <span class="subtitle-primary-medium-16 account-nav__action app-text-link--not-underline"
            (click)="logout()">Выйти</span>
        </div>
        <app-button *ngIf="scrolled" type="danger" 
          class="w-100 app-border-radius-100 h-56-px-i"
          [ngClass]="{'action_btn--floating --jc-center app-text-color-static': scrolled}" 
          (click)="toConfigurator()"
          >
          <span class="subtitle-primary-medium-16">Начать</span>
        </app-button>
      </ng-container>

      <ng-template #loginBtn>
        <div class=" action_btn --flex --align-center --gap-8 --crsr-pntr " (click)="scrolled ? toConfigurator() : toLogin()"
          [ngClass]="{'action_btn--floating --jc-center app-text-color-static': scrolled}">
          <app-svg *ngIf="!scrolled" src="/assets/img/auth.svg" type="stroke" subType="main"></app-svg>
          <span class="subtitle-primary-medium-16 app-text-link--not-underline">{{scrolled ? 'Начать' : 'Войти'}}</span>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>